export const HOME_HEALTH_VISIT_VERIFICATION_PATH = "/home-health/visit-verification";
